import { FC, useContext } from 'react'

import { NewServiceStatus } from '../../hooks/useTransformServiceItems/useTransformServiceItems'
import { RO_CLOSED } from '../../models/Status'
import { RepairOrderContext } from '../../providers/RepairOrderProvider/RepairOrderProvider'
import { ServiceTable } from './ServiceTable'

interface Props {
  statusFilterOption: NewServiceStatus | 'All'
  setStatusFilterOption: (status: NewServiceStatus | 'All') => void
}

export const ServiceTableContainer: FC<Props> = ({
  statusFilterOption,
  setStatusFilterOption
}) => {
  const { transformedServiceItems, repairOrder } =
    useContext(RepairOrderContext)

  const isEstimate = repairOrder?.entry?.info?.isEstimate
  const repairOrderVehicleId = repairOrder?.entry?.info?.vehicle
  const readOnly = repairOrder?.status?.id === RO_CLOSED

  return (
    <>
      {repairOrder && transformedServiceItems && (
        <ServiceTable
          serviceItems={transformedServiceItems}
          isEstimate={isEstimate!}
          repairOrderVehicleId={repairOrderVehicleId!}
          readOnly={readOnly}
          statusFilterOption={statusFilterOption}
          setStatusFilterOption={setStatusFilterOption}
        />
      )}
    </>
  )
}
